function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 34,
  height: 34,
  rx: 17,
  stroke: "white",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.8717 17.9562L23.6904 21.7748C23.8352 21.9196 23.8359 22.0636 23.6927 22.2068L22.2248 23.6748C22.0816 23.818 21.9376 23.8172 21.7928 23.6724L17.9742 19.8538L14.1791 23.6489C14.1194 23.7085 14.0476 23.7441 13.9637 23.7557C13.8796 23.7432 13.8074 23.7068 13.7471 23.6465L12.3355 22.2349C12.2751 22.1746 12.2448 22.1084 12.2444 22.0364C12.2439 21.9404 12.2734 21.8626 12.3331 21.8029L16.1282 18.0078L12.3277 14.2073C12.2674 14.1469 12.237 14.0808 12.2366 14.0088C12.2361 13.9128 12.2657 13.8349 12.3253 13.7753L13.7932 12.3073C13.8529 12.2477 13.9248 12.2241 14.0088 12.2365C14.0928 12.225 14.1649 12.2494 14.2252 12.3097L18.0258 16.1102L21.803 12.333C21.9462 12.1898 22.0902 12.1906 22.235 12.3354L23.6466 13.747C23.7914 13.8918 23.7922 14.0358 23.649 14.179L19.8717 17.9562Z",
  fill: "white"
});

function SvgButtonDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonDelete);
export default __webpack_public_path__ + "static/media/button_delete.b93b77b0.svg";
export { ForwardRef as ReactComponent };